/**
 * Entity klasa MfaSession - zarządza tymczasową sesją MFA
 * Przechowuje info o temp tokenie podczas weryfikacji MFA
 */
export class MfaSessionEntity {
  tempToken: string;
  userId: number;
  mfaMethod: 'email' | 'totp' | 'sms';
  createdAt: Date;
  expiresAt: Date;
  attemptsLeft: number;

  constructor(
    tempToken: string,
    userId: number,
    mfaMethod: 'email' | 'totp' | 'sms' = 'email',
    expiresInSeconds: number = 300, // 5 minut
    attemptsLeft: number = 3
  ) {
    this.tempToken = tempToken;
    this.userId = userId;
    this.mfaMethod = mfaMethod;
    this.createdAt = new Date();
    this.expiresAt = new Date(Date.now() + expiresInSeconds * 1000);
    this.attemptsLeft = attemptsLeft;
  }

  /**
   * Czy temp token jest ważny?
   */
  get isValid(): boolean {
    return new Date() < this.expiresAt && this.attemptsLeft > 0;
  }

  /**
   * Czy token wygasł?
   */
  get isExpired(): boolean {
    return new Date() >= this.expiresAt;
  }

  /**
   * Ile czasu zostało (w ms)
   */
  get timeRemaining(): number {
    return Math.max(0, this.expiresAt.getTime() - new Date().getTime());
  }

  /**
   * Zmniejsz próby
   */
  decrementAttempts(): void {
    this.attemptsLeft = Math.max(0, this.attemptsLeft - 1);
  }

  /**
   * Czy skończyły się próby?
   */
  get hasAttemptsLeft(): boolean {
    return this.attemptsLeft > 0;
  }

  /**
   * Wyczyść sesję
   */
  clear(): void {
    this.tempToken = '';
    this.userId = 0;
    this.attemptsLeft = 0;
    this.expiresAt = new Date(0);
  }
}
